"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  send: function send(data) {
    return global.request.post('feedbacks/send', data);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzZW5kIiwiZGF0YSIsImdsb2JhbCIsInJlcXVlc3QiLCJwb3N0Il0sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vbGlicmFyeS9zcmMvY2xpZW50L21vZHVsZXMvRmVlZGJhY2svRmVlZGJhY2tBY3Rpb25zLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcclxuICAgIHNlbmQ6IChkYXRhKSA9PiBnbG9iYWwucmVxdWVzdC5wb3N0KCdmZWVkYmFja3Mvc2VuZCcsIGRhdGEpLFxyXG59XHJcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O29DQUFlO0VBQ1hBLElBQUksRUFBRSxTQUFOQSxJQUFJQSxDQUFHQyxJQUFJO0lBQUEsT0FBS0MsTUFBTSxDQUFDQyxPQUFPLENBQUNDLElBQUksQ0FBQyxnQkFBZ0IsRUFBRUgsSUFBSSxDQUFDO0VBQUE7QUFDL0QsQ0FBQyJ9